export default __webpack_public_path__ + "f1493bd724fdc5418ad0be2489bc67a7.png";